module.exports = __webpack_public_path__ + "img/logo-studio57.bcdf960c.svg";